export var PIOversightStatus;
(function (PIOversightStatus) {
    PIOversightStatus["OVERDUE"] = "Overdue";
    PIOversightStatus["REVIEW_REQUIRED"] = "Review required";
    PIOversightStatus["CURRENT"] = "Current";
})(PIOversightStatus || (PIOversightStatus = {}));
